import { trackEvent } from "../utils/track-event";
import type { TrackingEvent, TrackingEventResponse } from "../utils/types";
import type { SegmentProductListMeta } from "src/segment";

type ProductListFilterResetEventProps = {
  meta: SegmentProductListMeta;
  resultId?: string;
};

type ProductListFilterResetAnalyticsProps = {
  result_id?: string;
  list_format: string;
  list_id: string;
  list_type: string;
  path: string;
  shop_type?: string;
};

export type ProductListFilterResetEvent = TrackingEvent<
  "Product List Filter Reset",
  ProductListFilterResetAnalyticsProps
>;

export async function trackProductListFilterResetEvent({
  meta,
  resultId,
}: ProductListFilterResetEventProps): TrackingEventResponse {
  const path = typeof window !== "undefined" ? window.location.pathname : "";

  return await trackEvent("Product List Filter Reset", {
    props: {
      result_id: resultId,
      list_format: meta.listFormat,
      list_id: meta.listId,
      list_type: meta.listType,
      path,
      shop_type: meta.shopType,
    },
    withRequestSource: true,
  });
}
